export default "<!--I'm an example of HTML-->\n<div>\n  <h1>My First Heading</h1>\n  <p>My first paragraph.</p>\n</div>";